//@ts-check
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '../../../../../core/Button';
import Icon from '../../../../../core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
var useStyles = makeStyles({
  button: {
    fontSize: '0.7rem',
    fontWeight: 'bolder',
    minWidth: 'auto',
    borderRadius: 8,
    opacity: 0.8
  },
  progress: {
    backgroundColor: '#337ab7 !important',
    '&:hover': {
      backgroundColor: '#337ab7 !important'
    }
  },
  error: {
    backgroundColor: 'red !important',
    '&:hover': {
      backgroundColor: 'red !important'
    }
  },
  success: {
    backgroundColor: 'green !important',
    '&:hover': {
      backgroundColor: 'green !important'
    }
  }
}, {
  name: 'ECJobProgress'
});
/** @param {import('../../data/types').JobStatus} status*/

var getTooltip = function getTooltip(status) {
  if (status === 'FinishedWithErrors') return 'Job finished with errors';
  if (status === 'Aborted') return 'Job was aborted';
  if (status === 'Processing') return 'Your job is running';
  if (status === 'FinishedOK') return 'Job finished with success';
  if (status === 'Starting') return 'You job is about to start';
  if (status === 'WaitingForTask') return 'Your job is in pending approval';
  if (status === 'WaitingForSignature') return 'Your job is Pending signature';
  return 'Your job is unknown status';
};
/**
 * @param {import('../../data/types').JobStatus} status
 * @param {number} progress
 */


var getMessage = function getMessage(status, progress) {
  if (status === 'FinishedWithErrors') return 'Failed';
  if (status === 'Aborted') return 'Job was aborted';
  if (status === 'Processing') return "Processing (".concat(progress, "%)");
  if (status === 'FinishedOK') return 'Succeeded (100%)';
  if (status === 'Starting') return 'Starting';
  if (status === 'WaitingForTask') return 'Pending approval';
  if (status === 'WaitingForSignature') return 'Pending signature';
  return 'Unknown status';
};
/**
 * @param {import('../../data/types').JobStatus} status
 * @return {string}
 */


var getClassName = function getClassName(status) {
  if (status === 'FinishedOK' || status === 'WaitingForTask' || status == 'WaitingForSignature') return 'success';
  if (status === 'FinishedWithErrors' || status === 'Aborted') return 'error';
  return 'progress';
};
/**
 * @param {import('./types').JobProgressProps} params
 */


var JobProgress = function JobProgress(_ref) {
  var onClick = _ref.onClick,
      progress = _ref.progress,
      status = _ref.status;
  var tooltip = getTooltip(status);
  var message = getMessage(status, progress);
  var inProgress = status === 'Processing' || status === 'Starting';
  var classes = useStyles({});
  return React.createElement(Tooltip, {
    title: tooltip,
    placement: "bottom"
  }, React.createElement(Button, {
    onClick: onClick,
    size: "small",
    className: cx(classes.button, classes[getClassName(status)])
  }, inProgress && React.createElement(Icon, {
    type: "loading",
    style: {
      marginRight: 5
    }
  }), message));
};

JobProgress.defaultProps = {
  onClick: function onClick() {}
};
export default JobProgress;